import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const { UPDATE_ASSESSMENT_FAILURE, UPDATE_ASSESSMENT_REQUEST, UPDATE_ASSESSMENT_SUCCESS } =
  therapyPlanningAction;

function* updateAssessment(payload: any): SagaReturnType<any> {
  try {
    const response = yield call(therapyPlanningService.updateAssessment, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: UPDATE_ASSESSMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_ASSESSMENT_FAILURE, payload: error });
  }
}

function* updateAssessmentSaga() {
  yield takeEvery(UPDATE_ASSESSMENT_REQUEST, updateAssessment);
}

export default updateAssessmentSaga;
